import { call, put, takeEvery, all, select } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import _ from "../../baseApp/shared/utils/ObjectUtils";
import { getEntityCall, editEntityCall, createEntityCall, deleteEntityCall } from "../../baseApp/entities/sagas";
import { availableEntityTypes } from '../otherEntities/utils';
import EntityUtils from './../../baseApp/entities/utils/EntityUtils';
import { getUserPageRefresh } from '../../baseApp/auth/sagas';

const controllerUrl = '/buildings/';

/*if (!axios.defaults.headers.common['Authorization']) {
    axios.get(process.env.REACT_APP_BACKEND_URL + "/auth/read-session").then(response => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;}).catch(e => console.log(e));
    }*/


const searchBuildingsCall = searchFields => new Promise((resolve, reject) => {
        axios.get(controllerUrl + 'search', {
            params: {
                ...searchFields,
            }
        }).then(
            response => resolve(response.data),
            error => reject(error)
        );
});

const getBuildingListCall = (filter = {}) => new Promise((resolve, reject) => {
        axios.get(controllerUrl + 'list', {
            params: filter
        }).then(
            response => resolve(response.data),
            error => reject(error)
        );
});


function* searchBuildingsRequest({ searchFields }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const searchResults = yield call(searchBuildingsCall, searchFields);
        const parentIds = searchResults.content.map(building => building.parentId);
        const uniqueParentIds = [...new Set(parentIds)];

        const parentEntities = yield all(
            uniqueParentIds
                .filter(id => !_.isNil(id))
                .map(id => call(getEntityCall, id))
        );
        const searchResultsWithParents = {
            ...searchResults,
            content: searchResults.content.map(
                building => {
                    const hasCheckInConfiguration = !_.isNilOrEmpty(building.checkInConfiguration);
                    return {
                        ...building,
                        parent: parentEntities.find(b => b.id === building.parentId),
                        hasCheckInConfiguration,
                        openTime: hasCheckInConfiguration ? building.checkInConfiguration.operationTimeStart : ' - - - ',
                        closeTime: hasCheckInConfiguration ? building.checkInConfiguration.operationTimeEnd : ' - - - '
                    }
                }
            )
        };
        yield put({
            type: actionTypes.BUILDING_SEARCH_SUCCESS,
            payload: searchResultsWithParents
        });
    } catch (e) {
        yield put({
            type: actionTypes.BUILDING_SEARCH_FAILED
        });
    }
}

function* getBuildingListRequest({ filter }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const buildingList = yield call(getBuildingListCall, filter);

        yield put({
            type: actionTypes.GET_BUILDING_LIST_SUCCESS,
            payload: buildingList.map(building => ({ value: building.id, label: building.name }))
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_BUILDING_LIST_FAILED
        });
    }
}

function* getBuildingRequest({ buildingId }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const building = yield call(getEntityCall, buildingId);

        building.parent = building.parentId;

        const buildingFEObject = EntityUtils.spreadEntityTypesSpecificData(
            availableEntityTypes.building, 
            building
        );

        yield put({
            type: actionTypes.GET_BUILDING_SUCCESS,
            payload: buildingFEObject
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_BUILDING_FAILED
        });
    }
}

function* createBuildingRequest({ buildingData }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        let buildingFormData = { ...buildingData };
        buildingFormData.parentId = buildingFormData.parent;
        buildingFormData.type = availableEntityTypes.building;
        buildingFormData = EntityUtils.addEntityTypesSpecificData(availableEntityTypes.building, buildingFormData);

        const building = yield call(createEntityCall, buildingFormData);

        yield put({
            type: actionTypes.CREATE_BUILDING_SUCCESS,
            payload: building
        });
    } catch (e) {
        yield put({
            type: actionTypes.CREATE_BUILDING_FAILED
        });
    }
}

function* editBuildingRequest({ buildingId, buildingData }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        let buildingFormData = { ...buildingData };
        buildingFormData.parentId = buildingFormData.parent;
        buildingFormData.type = availableEntityTypes.building;

        buildingFormData = EntityUtils.addEntityTypesSpecificData(availableEntityTypes.building, buildingFormData);

        const building = yield call(editEntityCall, buildingId, buildingFormData);

        yield put({
            type: actionTypes.EDIT_BUILDING_SUCCESS,
            payload: building
        });
    } catch (e) {
        yield put({
            type: actionTypes.EDIT_BUILDING_FAILED
        });
    }
}

function* deleteBuildingRequest({ buildingId }) {
    try {
        yield call(deleteEntityCall, buildingId);

        yield put({
            type: actionTypes.DELETE_BUILDING_SUCCESS
        });
    } catch (e) {
        yield put({
            type: actionTypes.DELETE_BUILDING_FAILED
        });
    }
}

const buildingsSagas = [
    takeEvery(actionTypes.GET_BUILDING_LIST_REQUEST, getBuildingListRequest),
    takeEvery(actionTypes.BUILDING_SEARCH_REQUEST, searchBuildingsRequest),
    takeEvery(actionTypes.GET_BUILDING_REQUEST, getBuildingRequest),
    takeEvery(actionTypes.CREATE_BUILDING_REQUEST, createBuildingRequest),
    takeEvery(actionTypes.EDIT_BUILDING_REQUEST, editBuildingRequest),
    takeEvery(actionTypes.DELETE_BUILDING_REQUEST, deleteBuildingRequest),
];

export {
    buildingsSagas
};